import {
  ApiUpdateMyWishlistRequestedAction,
  apiUpdateMyWishlistFailed,
  apiUpdateMyWishlistSucceeded
} from '@spa/lib/store/api/wishlists/updateMyWishlistApi';
import { call, put } from 'typed-redux-saga';
import { WishlistError } from '@spa/components/wishlist/wishlistTypes';
import logger from '@spa/lib/logger';
import updateMyWishlistAction from '@spa/lib/actions/wishlists/updateMyWishlistAction';

function* updateMyWishlistApiSaga({
  payload: { actionId: requestedActionId, input, parentActionId }
}: ApiUpdateMyWishlistRequestedAction): Generator {
  try {
    const result = yield* call(updateMyWishlistAction, 'updateMyWishlistAction', input);

    if (result.__typename === 'UpdateMyWishlistSucceededResult') {
      yield* put(apiUpdateMyWishlistSucceeded({ parentActionId, requestedActionId }));
    } else {
      yield* put(
        apiUpdateMyWishlistFailed({ errors: result.errors, parentActionId, requestedActionId })
      );
    }
  } catch (e) {
    logger.error({ err: e }, 'Error updating my wishlist');

    yield* put(
      apiUpdateMyWishlistFailed({
        errors: [WishlistError.UNKNOWN_ERROR],
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default updateMyWishlistApiSaga;
